import { PLATE_POOLING_OPTIONS } from 'src/constants/forms';

const orderPlatesAsOddEven = (plates) => {
  const orderedPlates = [];
  let j = 1;

  for (let i = 0; i < plates.length; i += 2) {
    orderedPlates.push({
      name: `Pooled Plates ${j}`,
      plateList: [plates[i].plateName, plates[i + 1].plateName],
    });
    j += 1;
  }

  return orderedPlates;
};

const orderPlatesAsHalves = (plates) => {
  const orderedPlates = [];
  let j = 1;

  for (let i = 0; i < plates.length / 2; i += 1) {
    orderedPlates.push({
      name: `Pooled Plates ${j}`,
      plateList: [
        plates[i].plateName,
        plates[i + plates.length / 2].plateName,
      ],
    });
    j += 1;
  }

  return orderedPlates;
};

export const orderPlates = (platePooling, plates) => {
  if (platePooling === PLATE_POOLING_OPTIONS.ODD_EVEN) {
    return orderPlatesAsOddEven(plates);
  }

  if (platePooling === PLATE_POOLING_OPTIONS.HALVES) {
    return orderPlatesAsHalves(plates);
  }

  return [];
};
